export default __webpack_public_path__ + "static/media/girl1.a2249125.png";